import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const PackageSelect = ({ options }) => {
  const [selectedOption, setSelectedOption] = useState();

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  return (
    <div style={ { width: '600px' } }>
      <input name="package_id"
             value={selectedOption && selectedOption.value}
             hidden
      />
      <SingleSelect
        handleChange={handleChange}
        options={options}
        selectedValue={selectedOption}
        placeholderText='Select Pricelist'
      />
    </div>
  );
};

PackageSelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

PackageSelect.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default PackageSelect;
